'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// From: http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
var getByteString = function getByteString(dataURI) {
    return dataURI.split(',')[0].indexOf('base64') >= 0 ? atob(dataURI.split(',')[1]) : decodeURI(dataURI.split(',')[1]);
};

var getMimeString = function getMimeString(dataURI) {
    return dataURI.split(',')[0].split(':')[1].split(';')[0];
};

var convertToTypedArray = function convertToTypedArray(dataURI) {
    var byteString = getByteString(dataURI);
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return ia;
};

exports.default = function (dataURI) {
    var mimeString = getMimeString(dataURI);
    var intArray = convertToTypedArray(dataURI);
    return new Blob([intArray], { type: mimeString });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/file/dataURIToBlob.js
// module id = 2132
// module chunks = 0